export {default} from './AnaChat';



// WEBPACK FOOTER //
// ./src/pages/AnaChat/index.ts